var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "6",
      "sm": "6"
    }
  }, [_c('statistic-card-horizontal', {
    attrs: {
      "icon": "LayersIcon",
      "color": "primary",
      "statistic": _vm.cardBarang,
      "statistic-title": "Barang"
    },
    on: {
      "onClick": function onClick($event) {
        return _vm.$router.push('/barang');
      }
    }
  })], 1), _c('b-col', {
    attrs: {
      "lg": "6",
      "sm": "6"
    }
  }, [_c('statistic-card-horizontal', {
    attrs: {
      "icon": "CreditCardIcon",
      "color": "success",
      "statistic": _vm.cardKendaraan,
      "statistic-title": "Total Kendaraan"
    },
    on: {
      "onClick": function onClick($event) {
        return _vm.$router.push('/kendaraan');
      }
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }